import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-people-list',
  templateUrl: './people-list.component.html',
  styleUrls: ['./people-list.component.scss']
})
export class PeopleListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  sortby(column: string): void{
    console.log('Tri par la colonne '+ column);
  }

}
